Math.avg = values => values.reduce((total, value) => total + parseFloat(value), 0) / values.length
Math.stdDev = (values, avg) => Math.sqrt(values.reduce((total, value) => total + Math.pow(parseFloat(value) - avg, 2), 0) / (values.length - 1))

export default class FormulaMode {
  static OPERATOR_MAP = {
    1: (val1, val2) => val1 === val2,
    2: (val1, val2) => val1 < val2,
    3: (val1, val2) => val1 <= val2,
    4: (val1, val2) => val1 > val2,
    5: (val1, val2) => val1 >= val2
  }

  static AccuracyCompletion = {
    getValue: ({inputValue, theoryValue}) => Number(((Math.avg(inputValue.split('|')) - parseFloat(theoryValue)) / parseFloat(theoryValue)).toFixed(7)),
    isQualified: ({sign, value, threshold}) => FormulaMode.OPERATOR_MAP[sign](Math.abs(value), threshold)
  }

  static PrecisionCompletion = {
    getValue: ({inputValue, theoryValue}) => {
      let values = inputValue.split('|')
      let avg = Math.avg(inputValue.split('|'))

      if (avg === 0) {
        return 1
      }

      return Math.stdDev(values, avg) / avg
    },
    isQualified: ({sign, value, threshold}) => FormulaMode.OPERATOR_MAP[sign](Math.abs(value), threshold)
  }
}



// WEBPACK FOOTER //
// ./src/model/FormulaMode.js